import { useTheme } from "styled-components";
var useBoldTypography = function useBoldTypography(typography) {
  var theme = useTheme();
  if (!typography) {
    return null;
  }
  var boldTypography = theme.typography[typography].boldTypography;
  if (!boldTypography) {
    return typography;
  }
  return boldTypography;
};
export default useBoldTypography;